import { render, staticRenderFns } from "./adminList.vue?vue&type=template&id=aa87e23c&"
import script from "./adminList.vue?vue&type=script&lang=js&"
export * from "./adminList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports